export const encryptionKeys = {
  iv: '6g5y6fdlctdegihk',
  key: '8pa7qohebhag5j2'
};
